import React, { useState } from 'react';
import { useAuth } from '../../api/services/auth';
import LoginForm from '../../components/loginForm';
import { Navigate } from 'react-router-dom';
import OtpForm from '../../components/otpVerificationForm';
import AuthLayout from '../../components/layout-components/AuthLayout';

const Login = (props) => {
    const { userExist, otpSent, showLoader } = useAuth();
    const [showForgotPasswordForm, setShowForgotPasswordForm] = useState(false);
    const [credentials, setCredentials] = useState({ username: '', password: '' });

    const handleLoginSuccess = (username, password) => {
        setCredentials({ username, password });
    };

    if (userExist) {
        return <Navigate to="/dashboard" />
    }

    const title = showForgotPasswordForm
        ? 'Request password reset'
        : otpSent
            ? 'Verify code'
            : 'Welcome back';

    const description = showForgotPasswordForm
        ? 'Enter your email to reset your password.'
        : otpSent
            ? 'Enter the OTP sent to your email.'
            : 'Enter your username and password to access your account.';

    return (
        <AuthLayout title={title} description={description}>
            {otpSent ? (
                <OtpForm
                    credentials={credentials}
                />
            ) : (
                <LoginForm
                    showForgotPasswordForm={showForgotPasswordForm}
                    setShowForgotPasswordForm={setShowForgotPasswordForm}
                    onLoginSuccess={handleLoginSuccess}
                />
            )}
        </AuthLayout>
    );
}

export default Login;
